import React, {
  forwardRef,
  SyntheticEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import "./OneQueryInput.css";
import "./FileUpload.css";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  getChatsOpen,
  regenerateResponse,
  resetUserInteracted,
  setDisabledVersions,
  setDisplayConAtBottom,
  setFileError,
  setIsGenerateImage,
  setIsGlobalSearch,
  setIsUserType,
  setModelOutputLanguage,
  setNewConversation,
  setParentMessageId,
  setShowSignPopup,
  setSnackBarAlert,
  toggleFullWidthMode,
} from "../../../../store/one-query/chatsSlice";
import { conversationsActions } from "../../../../store/one-query/conversationSlice";
import { useParams } from "react-router-dom";
import { useStopModels } from "../../../../store/Apis/ConversationApi";
import SignalRService from "../../../one-query/services/SignalRService";
import StopResponse from "./StopResponse";
import { PromptLibraryIcon } from "../../../../Custom-imeges/Prompt-library-icons/PromptLibraryIcon";
import { PromptLibrary } from "../Prompt-library/PromptLibrary";
import { setSelectedPromptLibrary } from "../../../../store/one-query/promptLibrarySlice";
import { LanguageModel } from "../Popups/LanguageModel";
import {
  allowedExtensionsFile,
  allowedExtensionsImage,
  MessageType,
  TranslatePromptLanguage,
} from "../../../../Helper";
import UploadFilesIcon from "../../../../Custom-imeges/UploadFilesIcon";
import {
  CircularProgress,
  IconButton,
  Switch,
  Tooltip,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import { ImprovePromptIcon } from "../../../../Custom-imeges/ImprovePromptIcon";
import { UndoIcon } from "../../../../Custom-imeges/UndoIcon";
import {
  TranslatePromptProps,
  useImprovePromptRequest,
  useTranslatePromptRequest,
} from "../../../../store/Apis/ChatModelApi";
import TranslateIcon from "@mui/icons-material/Translate";
import { OutputLangIcon } from "../../../../Custom-imeges/OutputLangIcon";
import {
  FileUploadMaxSize,
  getFileExtension,
  getFileNameWithoutExtsnions,
} from "../../../../FileAttachmentHelper";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { tooltipStyles } from "../../../TextSuite/Components/TextSuitesBody";
import Button from "@mui/material/Button";
import ListSubheader from "@mui/material/ListSubheader";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowUpIcon from "../../../../Custom-imeges/ArrowUpIcon";
import ArrowDown from "../../../../Custom-imeges/ArrowDown";
import LanguageIcon from "@mui/icons-material/Language";
const PromptLibTextStyle = {
  color: "var(--M-fontColor38)",
  fontSize: "14px",
  fontFamily: "Roboto",
  fontWeight: "400",
  display: { xs: "none", md: "block" },
};

const IOSSwitch = styled(Switch)(({ theme }) => ({
  width: 36, // Slightly wider for better touch interaction
  height: 20, // More balanced proportions
  padding: 0,
  display: "flex",
  alignItems: "center",

  "& .MuiSwitch-switchBase": {
    padding: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)", // Moves correctly within 36px width
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--M-background100)", // Active color
        opacity: 1,
      },
    },
  },

  "& .MuiSwitch-thumb": {
    width: 16, // Adjusted thumb size
    height: 16, // Matches track height with proper spacing
    backgroundColor: "#fff",
    boxShadow: "0px 2px 4px rgba(0,0,0,0.2)", // Natural shadow for depth
  },

  "& .MuiSwitch-track": {
    borderRadius: 10, // Ensures smooth rounded edges
    backgroundColor: "var(--M-background101)",
    opacity: 1,
    transition: "background-color 300ms",
  },
}));

enum ImprovePromptBtnType {
  Improve = 1,
  Undo,
  loading,
}

enum TranslatePromptBtnType {
  Translate = 1,
  Undo,
  loading,
}
export interface QueryInputProps
  extends React.RefAttributes<HTMLTextAreaElement> {
  handleSendQuery(
    query: string,
    FileUpload: FileList | null,
    imageUpload: { url: string; objectData: File[] | null } | null
  ): void;
  receieveUserImageQuery(imgQueryURL: File): void;
  inputDisabled: boolean;
  isResponseRegenerating: boolean;
  setSelectedOutputLang: (lang: string) => void;
  setShowImageGeneratorAlert: (value: boolean) => void;
}
interface CustomTextAreaElement extends HTMLTextAreaElement {
  handleDeleteUploadFile: () => void;
}
const OneQueryInput = forwardRef<CustomTextAreaElement, QueryInputProps>(
  (props, ref) => {
    const User = useAppSelector((s) => s.User);
    const [query, setQuery] = useState<string>();
    const ChatsStore = useAppSelector((state) => state.ChatsState);
    const isFullWidth = useAppSelector(
      (state) => state.ChatsState.fullWidthMode
    );
    const newConversation = useAppSelector(
      (state) => state.ChatsState.newConversation
    );
    const textAreaRef = useRef<any>(null);
    const [isButtonDisabled, setButtonDisabled] = useState(true);
    const [fileUpload, setFileUpload] = useState<any>("");
    const [imageUpload, setImageUpload] = useState<{
      url: string;
      objectData: File[] | null;
    }>({ url: "", objectData: null });
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [isIconDeleteAppear, setIsIconDeleteAppear] = useState(false);
    const dispatch = useAppDispatch();
    const [triggerSend, setTriggerSend] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const regenerateMsg = useAppSelector((s) => s.ChatsState.reGenerateMessage);
    const [isFileError, setIsFileError] = useState(false);
    const { id } = useParams<{ id: string }>();
    const maximizedChat = useAppSelector((s) => s.ChatsState.maximizedChat);
    const modelsChats = useAppSelector((s) => s.chatModel.chatModelData);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [inputAnimation, setInputAnimation] = useState(false);
    const [openPromptLibrary, setOpenPromptLibrary] = useState(false);
    const PromptLibraryStore = useAppSelector((s) => s.PromptLibrary);
    const [isMobile, setIsMobile] = useState(false);
    const isMaxChatReceivesRes = modelsChats.some(
      (obj) =>
        (obj.version === maximizedChat?.versionName && obj.isRegernating) ||
        obj.isEditing
    );
    const [translatedMessage, setTranslatedMessage] = useState<string>("");
    const [isTranslationLoading, setIsTranslationLoading] = useState(false);
    const [isImproveLoading, setIsImproveLoading] = useState(false);
    const [isTranslatedCanceled, setIsTranslatedCanceled] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [improveBtnType, setImproveBtnType] = useState<number>(
      ImprovePromptBtnType.Improve
    );
    const [originalImprovePrompt, setOriginalImprovePrompt] = useState<
      string | undefined
    >(query);
    const [isImprovedCanceled, setIsImprovedCanceled] = useState(false);
    const [improvedMessage, setImprovedMessage] = useState<string>("");
    const {
      mutate: improvePromptRequest,
      isPending,
      isSuccess,
    } = useImprovePromptRequest();
    const { mutate, isPending: isTransaltePending } =
      useTranslatePromptRequest();
    const [selectedPromptLang, setSelectedPromptLang] = useState(
      TranslatePromptLanguage[0]
    );
    const [translatedPrompt, setTranslatedPrompt] = useState<
      string | undefined
    >();
    const [originalPrompt, setOriginalPrompt] = useState<string | undefined>(
      query
    );
    const [translateBtnType, setTranslateBtnType] = useState<number>(
      TranslatePromptBtnType.Translate
    );
    const [openLanguagesModal, setOpenLanguagesModal] = useState(false);
    const [selectedOutputLang, setSelectedOutputLang] = useState("");
    const [languageModalType, setLanguageModalType] =
      useState<string>("Prompt");
    const [isFinished, setIsFinished] = useState(false);
    const label = { inputProps: { "aria-label": "Switch demo" } };
    const mobileSize = useMediaQuery("(max-width:900px)");
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const ContinerModeRef=useRef<HTMLDivElement>(null);
    const handleClick = () => {
      if (ContinerModeRef.current) {
        setAnchorEl(ContinerModeRef.current);
      }
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const tooltipStyle = {
      ...tooltipStyles,
      tooltip: {
        sx: {
          bgcolor: "var(--M-background103) !important",
          color: "var(--M-background104) !important",
        },
      },
      arrow: { sx: { color: "var(--M-background103) !important" } },
    };
    const BtnStyle = {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      opacity: query && query.trim() ? 1 : 0.5,
      borderRadius: "25px",
      textTransform: "unset",
      padding: { md: "6px 8px" },
      cursor: query && query.trim() ? "pointer" : "default",
      ":hover": {
        bgcolor: "var(--A_backgroundColor75)",
      },
    };
    const BtnItemStyleForOption = {
      display: "flex",
      alignItems: "center",
      jusitfyContent: "spaceBetween",
      gap: "4px",
      opacity: 1,
      bgcolor: "transparent",
      borderRadius: "0px",
      width: "100%",
      boxShadow:
        query && query.trim()
          ? "0px 4px 4px 0px rgba(17, 24, 27, 0.24)"
          : "none",
      textTransform: "unset",
      cursor: query && query.trim() ? "pointer" : "default",
      padding: "8px 0px !important",
      "@media (max-width: 900px)": {
        backgroundColor: "transparent !important",
      },
      ":hover": {
        bgcolor: "transparent",
      },
    };
    const PromptLibBtnStyle = {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      borderRadius: "25px",
      textTransform: "unset",
      boxShadow: "none",
      padding: { md: "6px 8px" },
      opacity: ChatsStore.isGenerateImage ? "0.5" : "1",
      ":hover": {
        bgcolor: "var(--A_backgroundColor75)",
      },
    };

    const handleSwitchGenerateImageChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      if (!ChatsStore.isGenerateImage) {
        dispatch(setDisabledVersions([]));
      }
      dispatch(setIsGenerateImage(event.target.checked));
      dispatch(setIsGlobalSearch(false));
    };
    const handleSwitchGlobalSearchChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      dispatch(setIsGlobalSearch(event.target.checked));
      dispatch(setIsGenerateImage(false));
    };

    const handleSwitchGenerateImage = () => {
      let generateImageState = ChatsStore.isGenerateImage;
      dispatch(setIsGenerateImage(!ChatsStore.isGenerateImage));
      if (!generateImageState)
        // This means we enable generate Image so close Global search
        dispatch(setIsGlobalSearch(false));
    };
    const handleSwitchGlobalSearch = () => {
      let globalSearchState = ChatsStore.isGlobalSearch;
      dispatch(setIsGlobalSearch(!ChatsStore.isGlobalSearch));
      if (!globalSearchState)
        // This mean we enable global search so close Generate image
        dispatch(setIsGenerateImage(false));
    };

    useEffect(() => {
      if (isFinished) {
        setTranslatedMessage("");
        setImprovedMessage("");
        setIsButtonLoading(false);
        setIsTranslationLoading(false);
        setIsImproveLoading(false);
        setIsFinished(false);
      }
    }, [isFinished]);

    const handleTranslateAndImproveMessage = useCallback(
      (
        modelName: string,
        modelVersion: string,
        message: string,
        tag: string,
        conversationId: string,
        messageId: string,
        messageType: number
      ) => {
        if (message === "**/**Finished**/**") {
          setIsFinished(true);
        } else {
          if (messageType === MessageType.Translate) {
            setIsButtonLoading(true);
            setIsTranslationLoading(true);
            setTranslatedMessage((prev) => prev + message);
          } else if (messageType === MessageType.Enhance) {
            setIsImproveLoading(true);
            setImprovedMessage((prev) => prev + message);
          }
        }
      },
      []
    );

    const setupSignalRConnection = useCallback(() => {
      const connection = SignalRService.getInstance().connection;
      connection.on("SendModelMessage", handleTranslateAndImproveMessage);
      return () => {
        connection.off("SendModelMessage", handleTranslateAndImproveMessage);
      };
    }, [handleTranslateAndImproveMessage]);

    useEffect(() => {
      const cleanup = setupSignalRConnection();
      return () => {
        cleanup();
      };
    }, [setupSignalRConnection]);

    useEffect(() => {
      if (translatedMessage && textAreaRef.current) {
        setQuery("");
        textAreaRef.current.innerText = "";
        textAreaRef.current.value = "";
        setQuery(translatedMessage);
        textAreaRef.current.innerText = translatedMessage;
        textAreaRef.current.value = translatedMessage;
      }
    }, [translatedMessage]);

    useEffect(() => {
      if (improvedMessage && textAreaRef.current) {
        setQuery("");
        textAreaRef.current.innerText = "";
        textAreaRef.current.value = "";
        setQuery(improvedMessage);
        textAreaRef.current.innerText = improvedMessage;
        textAreaRef.current.value = improvedMessage;
      }
    }, [improvedMessage]);

    const stopModelsRequest = useStopModels();

    const handleOpenPromptLibrary = () => {
      setOpenPromptLibrary(true);
    };

    const handleClosePromptLibrary = () => {
      setOpenPromptLibrary(false);
    };

    const handleSetLibraryPrompt = (prompt: string) => {
      setQuery(prompt);

      if (textAreaRef.current) {
        textAreaRef.current.innerText = prompt;
        textAreaRef.current.focus();
        setButtonDisabled(prompt.trim() === "");
      }

      handleInputFocus();
      handleClosePromptLibrary();
      setImproveBtnType(ImprovePromptBtnType.Improve);
    };

    const onTextAreaInputChanged = (e: SyntheticEvent) => {
      if (textAreaRef.current) {
        textAreaRef.current.style.height = "auto";
        textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
      }
      setButtonDisabled(
        !textAreaRef.current || textAreaRef.current.innerText.trim() === ""
      );
      const text =
        textAreaRef?.current?.innerText || textAreaRef?.current?.value;
      setQuery(text);
      setInputAnimation(false);
      setImproveBtnType(ImprovePromptBtnType.Improve);
    };

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
      if (triggerSend && !isButtonDisabled && textAreaRef.current && query) {
        dispatch(resetUserInteracted());
        setButtonDisabled(true);
        setTriggerSend(false);
      }
    }, [triggerSend, isButtonDisabled]);

    const handleSendClick = () => {
      if (textAreaRef.current) {
        const text =
          textAreaRef?.current?.innerText || textAreaRef?.current?.value;
        if (text && text.trim()) {
          // Set trigger for sending request
          setTriggerSend(true);
          dispatch(setDisplayConAtBottom(false));
          textAreaRef.current.style.height = "auto";
          if (query !== "") {
            const trimmedQuery = query?.trim() || "";
            if (imageUpload.url)
              props.handleSendQuery(trimmedQuery, null, imageUpload);
            else props.handleSendQuery(trimmedQuery, fileUpload, null);

            dispatch(resetUserInteracted());
            dispatch(setNewConversation(false));
            dispatch(conversationsActions.setIsNewConversation(false));
            dispatch(regenerateResponse(false));

            // Clear the input and file state
            setQuery("");
            setFileUpload("");
            setImageUpload({ url: "", objectData: null });
            setIsFileUploaded(false);
            if (textAreaRef.current) {
              textAreaRef.current.innerText = "";
              textAreaRef.current.value = "";
            }
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
          }
          setImproveBtnType(ImprovePromptBtnType.Improve);
          setTranslateBtnType(TranslatePromptBtnType.Translate);
        }
      }
    };

    const addNewLine = () => {
      const text =
        textAreaRef?.current?.innerText || textAreaRef?.current?.value;

      const updatedText = text + "\n";

      if (textAreaRef?.current) {
        textAreaRef.current.value = updatedText;
        textAreaRef.current.innerText = updatedText;
      }
      setQuery(updatedText);
    };

    const handleKeyDown = (event: React.KeyboardEvent<any>) => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault(); // Prevent default 'Enter' behavior in contentEditable

        if (isMobile) {
          // Add a newline for mobile devices
          addNewLine();
        } else {
          if (textAreaRef.current && query !== "") {
            // Set the query and trigger the send action
            if (textAreaRef.current) {
              const text =
                textAreaRef?.current?.innerText || textAreaRef?.current?.value;
              setQuery(text);
              handleSendClick();
            }
          }
        }
      }
    };

    useEffect(() => {
      if (regenerateMsg.length > 0) {
        if (textAreaRef.current) {
          if (query != "") {
            textAreaRef.current.innerText = "";
            textAreaRef.current.value = "";
            setQuery("");
          }
          setQuery(regenerateMsg);
          textAreaRef.current.innerText = regenerateMsg;
          textAreaRef.current.value = regenerateMsg;
          textAreaRef.current.focus();
        }
      }
    }, [regenerateMsg]);

    const handleDeleteUploadFile = () => {
      setFileUpload("");
      setImageUpload({ url: "", objectData: null });
      setIsFileUploaded(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    };

    const handleImageClick = () => {
      fileInputRef.current?.click();
    };

    const handleImageLoad = (imageFile: any) => {
      const imageUrl = URL.createObjectURL(imageFile);
      setImageUpload((prev) => ({ ...prev, url: imageUrl }));
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      if (files) {
        // Define allowed extensions
        if (files[0].type.includes("image")) {
          setFileUpload("");
          // Filter files based on allowed extensions
          const validImage = Array.from(files).filter((file) =>
            allowedExtensionsImage?.includes(getFileExtension(file.name)?.toLowerCase()||"")
          );
          if (validImage.length > 0) {
            handleImageLoad(validImage[0]);
            setImageUpload((prev) => ({ ...prev, objectData: validImage }));
            setIsFileUploaded(true);
          } else {
            setImageUpload({ url: "", objectData: null });
            setIsFileUploaded(false);
            fileInputRef.current!.value = ""; // Clear the input
            dispatch(
              setFileError({
                isError: true,
                errorMsg:
                  "Image type not supported. Use JPG, JPEG, PNG, or WEBP.",
                reason: "user upload file type not support",
              })
            );
          }
        } else {
          // Filter files based on allowed extensions
          const validFiles = Array.from(files).filter((file) =>
            allowedExtensionsFile?.includes(getFileExtension(file.name)?.toLowerCase()||"")
          );

          if (validFiles.length > 0) {
            setFileUpload(validFiles); // Only set valid files
            setIsFileUploaded(true);
          } else {
            setFileUpload("");
            setIsFileUploaded(false);
            fileInputRef.current!.value = ""; // Clear the input
            dispatch(
              setFileError({
                isError: true,
                errorMsg: "File type not supported. Use PDF, DOC, or Excel.",
                reason: "user upload file type not support",
              })
            );
          }
        }
      }
    };

    const handleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files.length > 0) {
        const uploadedFile = event.target.files[0];
        if (uploadedFile.size > FileUploadMaxSize) {
          dispatch(
            setFileError({
              isError: true,
              errorMsg: "The uploaded file exceeds the limit allowed (10MB)",
              reason: "file upload excced 10MB",
            })
          );
          setIsFileError(true);
        }
      }
    };

    useEffect(() => {
      if (isFileError) {
        // Optionally, add a delay before resetting the error state
        const timer = setTimeout(() => {
          handleDeleteUploadFile();
          setIsFileError(false);
        }, 3000);

        return () => clearTimeout(timer); // Cleanup timeout
      }
    }, [isFileError]);

    // useEffect to handle writing & selection text in the user input.
    useEffect(() => {
      if (query && query?.length > 0) {
        dispatch(setIsUserType(true));
        dispatch(setParentMessageId(null));
      } else {
        dispatch(setIsUserType(false));
      }

      if (PromptLibraryStore.selectedPromptLibrary.id && textAreaRef.current) {
        const regex = /\[([^\]]+)\]/g;
        const text = query || "";

        // Save the current caret position
        const selection = window.getSelection();
        let caretOffset = 0;
        if (selection?.rangeCount && selection?.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          const preCaretRange = range.cloneRange();
          preCaretRange.selectNodeContents(textAreaRef.current);
          preCaretRange.setEnd(range.endContainer, range.endOffset);
          caretOffset = preCaretRange.toString().length;
        }

        // Replace content with highlighted text
        const highlightedHTML = text.replace(regex, (match) => {
          const spanElement = document.createElement("span");
          spanElement.className = "highlightedText";
          spanElement.innerHTML = match;

          return spanElement.outerHTML;
        });

        textAreaRef.current.innerHTML = highlightedHTML;

        textAreaRef.current.addEventListener("click", (event: any) => {
          const target = event.target as HTMLElement;
          if (target && target.classList.contains("highlightedText")) {
            selectSpanContent(event);
          }
        });

        // Restore caret position
        if (selection) {
          const range = document.createRange();
          let currentOffset = 0;
          const walker = document.createTreeWalker(
            textAreaRef.current,
            NodeFilter.SHOW_TEXT,
            null
          );

          let node;
          while ((node = walker.nextNode()) && currentOffset < caretOffset) {
            if (node.textContent) {
              const nodeLength = node.textContent.length;
              if (currentOffset + nodeLength >= caretOffset) {
                const offsetInNode = caretOffset - currentOffset;
                range.setStart(node, offsetInNode);
                range.collapse(true);
                break;
              }
              currentOffset += nodeLength;
            }
          }

          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    }, [
      improvedMessage,
      translatedMessage,
      PromptLibraryStore.selectedPromptLibrary.id,
    ]);

    useEffect(() => {
      if (
        textAreaRef.current &&
        query?.trim() === "" &&
        PromptLibraryStore?.selectedPromptLibrary?.id
      ) {
        setQuery("");
        dispatch(
          setSelectedPromptLibrary({
            id: "",
            type: "",
            title: "",
            subType: "",
            createdAt: "",
            promptContent: "",
            isPro: false,
            isDeleted: false,
            contentLength: 0,
          })
        );
      }
    }, [query, PromptLibraryStore?.selectedPromptLibrary.id]);
    // Function to select span content
    const selectSpanContent = (event: any) => {
      const range = document.createRange();
      const selection = window.getSelection();

      range.selectNodeContents(event.target);
      selection?.removeAllRanges();
      selection?.addRange(range);
    };

    useEffect(() => {
      SignalRService.getInstance();
    }, []);
    const handleInputFocus = () => {
      textAreaRef.current?.focus();
      setIsInputFocused(true);
    };

    useEffect(() => {
      if (newConversation && textAreaRef.current) {
        setInputAnimation(true);
        setSelectedOutputLang("");
        setImageUpload({ url: "", objectData: null });
        setFileUpload("");
        setIsFileUploaded(false);
        props.setSelectedOutputLang("");
      } else {
        setInputAnimation(false);
      }
      setQuery("");
      textAreaRef.current.innerText = "";
      textAreaRef.current.value = "";
    }, [newConversation]);

    //================================================================================================
    // Improve prompt logic

    const handleImprovePromptRequest = async (prompt: string | undefined) => {
      const connectionId = await SignalRService.getInstance().getConnectionId();
      if (prompt && connectionId) {
        setImprovedMessage("");
        setTranslateBtnType(TranslatePromptBtnType.Translate);
        improvePromptRequest({ prompt, connectionId });
        setIsImprovedCanceled(false);
        setOriginalImprovePrompt(prompt);
      }
    };

    const handleUndoImprovePrompt = () => {
      if (originalImprovePrompt) {
        setQuery(originalImprovePrompt);
        setImprovedMessage(originalImprovePrompt);
        if (textAreaRef.current) {
          textAreaRef.current.innerText = "";
          textAreaRef.current.innerText = originalImprovePrompt;
        }
        setIsImprovedCanceled(false);
        setImproveBtnType(ImprovePromptBtnType.Improve);
      }
    };

    const handleCancelImprovePrompt = () => {
      if (isPending) {
        setIsImprovedCanceled(true);
        setImproveBtnType(ImprovePromptBtnType.Improve);
      }
    };

    useEffect(() => {
      if (isPending) {
        setImproveBtnType(ImprovePromptBtnType.loading);
      }
    }, [isPending]);
    useEffect(() => {
      if (isTransaltePending)
        setTranslateBtnType(TranslatePromptBtnType.loading);
    }, [isTransaltePending]);
    const ImproveBtnText =
      improveBtnType === ImprovePromptBtnType.Improve
        ? "Improve prompt"
        : improveBtnType === ImprovePromptBtnType.Undo
        ? "Undo"
        : improveBtnType === ImprovePromptBtnType.loading && "Improving";

    //================================================================================================
    // Translate prompt logic
    const createTranslatePromptRequest =
      async (): Promise<TranslatePromptProps | null> => {
        const connectionId =
          await SignalRService.getInstance().getConnectionId();
        return connectionId && query && selectedPromptLang
          ? { prompt: query, connectionId, language: selectedPromptLang }
          : null;
      };

    const handleTranslate = async () => {
      if (query && selectedPromptLang) {
        try {
          const translatePromptRequest = await createTranslatePromptRequest();
          if (translatePromptRequest) {
            setTranslatedMessage("");
            mutate(translatePromptRequest);
            setTranslatedPrompt(query);
            setIsTranslatedCanceled(false);
            setOpenLanguagesModal(false);
            setImproveBtnType(ImprovePromptBtnType.Improve);
          }
        } catch (error) {
          console.error(error);
        }
      }
    };
    const handleUndoTranslatePrompt = () => {
      if (translatedPrompt) {
        setQuery(translatedPrompt);
        setTranslatedMessage(translatedPrompt);
        if (textAreaRef.current) {
          textAreaRef.current.innerText = "";
          textAreaRef.current.innerText = translatedPrompt;
        }
        setIsTranslatedCanceled(false);
        setTranslateBtnType(TranslatePromptBtnType.Translate);
      }
    };

    const handleCancelTranslatePrompt = () => {
      if (isTranslationLoading) {
        setQuery(translatedPrompt);
        setIsTranslatedCanceled(true);
        setTranslateBtnType(TranslatePromptBtnType.Translate);
      }
    };

    const handleSelectLanguage = (lang: string) => {
      if (languageModalType === "Prompt") {
        setSelectedPromptLang(lang);
      } else {
        props.setSelectedOutputLang(lang);
        setSelectedOutputLang(lang);
        dispatch(setModelOutputLanguage(lang))
      }
    };

    const handleSelectTranslatePromptLang = () => {
      setOpenLanguagesModal(true);
      setLanguageModalType("Prompt");
    };

    const handleSelectTranslateOutputLang = () => {
      setOpenLanguagesModal(true);
      setLanguageModalType("Output");
    };

    useEffect(() => {
      if (isTranslationLoading) {
        setTranslateBtnType(TranslatePromptBtnType.loading);
      } else if (!isTranslationLoading && !translatedPrompt) {
        setTranslateBtnType(TranslatePromptBtnType.Translate);
      } else if (!isTranslationLoading && translatedPrompt) {
        setTranslateBtnType(TranslatePromptBtnType.Undo);
      }
    }, [isTranslationLoading]);

    useEffect(() => {
      if (isImproveLoading) {
        setImproveBtnType(ImprovePromptBtnType.loading);
      } else if (!isImproveLoading && !originalImprovePrompt) {
        setImproveBtnType(ImprovePromptBtnType.Improve);
      } else if (!isImproveLoading && originalImprovePrompt) {
        setImproveBtnType(ImprovePromptBtnType.Undo);
      }
    }, [isImproveLoading]);

    useEffect(() => {
      if (
        translateBtnType === TranslatePromptBtnType.Undo &&
        query !== originalPrompt
      ) {
        setTranslateBtnType(TranslatePromptBtnType.Translate);
      }
    }, [query, originalPrompt]);

    const translatePromptBtnText =
      translateBtnType === TranslatePromptBtnType.Translate
        ? "Translate"
        : translateBtnType === TranslatePromptBtnType.Undo
        ? "Undo"
        : translateBtnType === TranslatePromptBtnType.loading && "Translating";

    // =========================================================
    // handle logic of generate image option.
    useEffect(() => {
      if (ChatsStore.isGenerateImage) {
        props.setShowImageGeneratorAlert(true);
      }
      if (ChatsStore.isGenerateImage && !User.IsAuthenticated) {
        dispatch(getChatsOpen({ chatsNum: 1, selectedOptions: ["ChatGPT"] }));
        dispatch(toggleFullWidthMode(""));
      } else if (
        ChatsStore.isGenerateImage &&
        User.IsAuthenticated &&
        ChatsStore.chatsNum >= 2
      ) {
        dispatch(
          getChatsOpen({ chatsNum: 2, selectedOptions: ["ChatGPT", "Gemini"] })
        );
        dispatch(toggleFullWidthMode(""));
      } else if (
        ChatsStore.isGenerateImage &&
        User.IsAuthenticated &&
        ChatsStore.chatsNum < 2
      ) {
        dispatch(getChatsOpen({ chatsNum: 1, selectedOptions: ["ChatGPT"] }));
        dispatch(conversationsActions.RemoveSecondIndexInLastActive());
        dispatch(toggleFullWidthMode(""));
      }
    }, [ChatsStore.isGenerateImage]);

    let inputPlaceHolder = ChatsStore.isGenerateImage
      ? "Describe the image you want to generate in detail.."
      : "Start your conversation here...";

    return (
      <div
        className={`chat-box ${
          isFullWidth !== "" && isFullWidth !== "ExpertHome" ? "fullWidth" : ""
        } 
      ${newConversation && "new-conversation"} ${
          isInputFocused && "input-focused"
        }`}
        style={isFileUploaded ? { minHeight: "200px" } : {}}
      >
        <div className="chatBoxTextDiv">
          <div className="uploadedFiles">
            {isFileUploaded && fileUpload ? (
              <div
                className="d-flex flex-row containerFileUpload"
                onMouseOver={() => setIsIconDeleteAppear(true)}
                onMouseLeave={() => setIsIconDeleteAppear(false)}
                style={{ marginLeft: "10px" }}
              >
                <img
                  className="me-3"
                  src={
                    fileUpload[0]?.name.includes("pdf")
                      ? "/Images/GetConversations/icn-pdf-light.svg"
                      : fileUpload[0]?.name.includes("doc") ||
                        fileUpload[0]?.name.includes("docx")
                      ? "/Images/GetConversations/icn-doc-light.svg"
                      : "/Images/GetConversations/icn-xlsx-light.svg"
                  }
                />
                <div className="d-flex flex-column fileName">
                  <span>
                    {getFileNameWithoutExtsnions(fileUpload[0]?.name)}
                  </span>
                  <span>.{getFileExtension(fileUpload[0]?.name)}</span>
                </div>
                {isIconDeleteAppear && (
                  <div className="overlay">
                    <img
                      className="close-icon c-pointer"
                      src="/Images/GetConversations/cancel.svg"
                      onClick={handleDeleteUploadFile}
                    ></img>
                  </div>
                )}
              </div>
            ) : (
              isFileUploaded &&
              imageUpload.url && (
                <div className="uploaded-image-input">
                  <div
                    className="position-relative w-100"
                    style={{ margin: "6px 12px 0px 12px" }}
                    onMouseOver={() => setIsIconDeleteAppear(true)}
                    onMouseLeave={() => setIsIconDeleteAppear(false)}
                  >
                    <img
                      src={imageUpload.url}
                      className="uploaded-image-input"
                      alt="uploaded"
                    />
                    {isIconDeleteAppear && (
                      <div className="overlay-image">
                        <img
                          className="close-icon c-pointer"
                          src="/Images/GetConversations/cancel.svg"
                          onClick={handleDeleteUploadFile}
                        ></img>
                      </div>
                    )}
                  </div>
                </div>
              )
            )}
          </div>
          <div className="containerTextAndButtons">
            {PromptLibraryStore.selectedPromptLibrary.id ? (
              <div
                className="textarea highlighted"
                ref={textAreaRef}
                contentEditable={true}
                onInput={onTextAreaInputChanged}
                onKeyDown={handleKeyDown}
                onFocus={() => setIsInputFocused(true)}
                onBlur={() => setIsInputFocused(false)}
                suppressContentEditableWarning={true}
                style={isFileUploaded ? { maxHeight: "50px" } : {}}
              />
            ) : (
              <textarea
                className="textarea highlighted pb-0"
                style={
                  isFileUploaded ? { marginTop: "0px", paddingTop: "2px",maxHeight:"60px"} : {}
                }
                ref={textAreaRef}
                contentEditable={true}
                onInput={onTextAreaInputChanged}
                onKeyDown={handleKeyDown}
                onFocus={() => setIsInputFocused(true)}
                onBlur={() => setIsInputFocused(false)}
                suppressContentEditableWarning={true}
              />
            )}
            {query?.length === 0 ? (
              <div
                className={`input-welcome-msg ${
                  inputAnimation ? "input-animation" : ""
                }`}
                onClick={handleInputFocus}
                style={isFileUploaded ? { top: "-10px" } : {}}
              >
                <span className="input-welcome-msg-text">
                  {inputPlaceHolder}
                </span>
              </div>
            ) : null}
            <div className={`chatBoxButtonDiv ${id && "in-chat"}`}>
              <div className="prompt-library-container">
                <div>
                  <Tooltip
                    title="Turn off image generation mode"
                    arrow
                    componentsProps={tooltipStyle}
                    disableHoverListener={
                      !ChatsStore.isGenerateImage || mobileSize
                    }
                    disableFocusListener={
                      !ChatsStore.isGenerateImage || mobileSize
                    }
                  >
                    <span>
                      <IconButton
                        sx={{
                          padding: "4px",
                          ":hover": {
                            bgcolor: "var(--A_backgroundColor75)",
                          },
                        }}
                        onClick={handleImageClick}
                        disabled={isButtonLoading || ChatsStore.isGenerateImage}
                      >
                        <UploadFilesIcon
                          className={`upload-icon ${
                            ChatsStore.isGenerateImage && "opacity-50"
                          }`}
                        />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <input
                    disabled={!props.isResponseRegenerating}
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.webp"
                    onChange={handleFileChange}
                    onInput={handleFileInput}
                  />
                </div>
                <div className="prompt-line"></div>
                <Tooltip
                  title="Turn off image generation mode"
                  arrow
                  componentsProps={tooltipStyle}
                  disableHoverListener={
                    !ChatsStore.isGenerateImage || mobileSize
                  }
                  disableFocusListener={
                    !ChatsStore.isGenerateImage || mobileSize
                  }
                >
                  <span>
                    <IconButton
                      sx={PromptLibBtnStyle}
                      disabled={isButtonLoading || ChatsStore.isGenerateImage}
                      onClick={handleOpenPromptLibrary}
                    >
                      <PromptLibraryIcon className="prompt-lib-icn" />
                      <Typography sx={PromptLibTextStyle}>
                        Prompt library
                      </Typography>
                    </IconButton>
                  </span>
                </Tooltip>
                {/*Improve prompt button*/}
                <Tooltip
                  title="Write a prompt"
                  arrow
                  componentsProps={tooltipStyle}
                  disableHoverListener={!!query || mobileSize}
                  disableFocusListener={!!query || mobileSize}
                >
                  <span>
                    <IconButton
                      sx={BtnStyle}
                      disabled={
                        !query ||
                        !query.trim() ||
                        (isButtonLoading && !isPending)
                      }
                      onClick={
                        improveBtnType === ImprovePromptBtnType.Improve
                          ? () => handleImprovePromptRequest(query)
                          : improveBtnType === ImprovePromptBtnType.Undo
                          ? () => handleUndoImprovePrompt()
                          : undefined
                      }
                    >
                      {improveBtnType === ImprovePromptBtnType.loading ? (
                        <CircularProgress size={18} />
                      ) : improveBtnType === ImprovePromptBtnType.Improve ? (
                        <ImprovePromptIcon className={`improvePromptIcon`} />
                      ) : improveBtnType === ImprovePromptBtnType.Undo ? (
                        <UndoIcon className="improvePromptIcon" />
                      ) : null}
                      <Typography sx={PromptLibTextStyle}>
                        {ImproveBtnText}
                      </Typography>
                    </IconButton>
                  </span>
                </Tooltip>
                {/*Translate prompt button*/}
                <Tooltip
                  title="Write a prompt"
                  arrow
                  componentsProps={tooltipStyle}
                  disableHoverListener={!!query || mobileSize}
                  disableFocusListener={!!query || mobileSize}
                >
                  <span>
                    <IconButton
                      disabled={
                        !query ||
                        !query.trim() ||
                        (isButtonLoading && !isTranslationLoading)
                      }
                      sx={BtnStyle}
                      onClick={
                        translateBtnType === TranslatePromptBtnType.Translate
                          ? () => handleSelectTranslatePromptLang()
                          : translateBtnType === TranslatePromptBtnType.Undo
                          ? () => handleUndoTranslatePrompt()
                          : undefined
                      }
                    >
                      {translateBtnType === TranslatePromptBtnType.loading ? (
                        <CircularProgress size={18} />
                      ) : translateBtnType ===
                        TranslatePromptBtnType.Translate ? (
                        <TranslateIcon sx={{ color: "var(--M-fontColor38)" }} />
                      ) : translateBtnType === TranslatePromptBtnType.Undo ? (
                        <UndoIcon className="improvePromptIcon" />
                      ) : null}
                      <Typography sx={PromptLibTextStyle}>
                        {translatePromptBtnText}
                      </Typography>
                    </IconButton>
                  </span>
                </Tooltip>
                {/*Translate output button*/}
                <div className="position-absolute end-0 d-flex align-items-center">
                  {/*Generate image button and web search*/}
                  <div className="Continer-mode">
                    <List component="nav">
                      <ListItemButton
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: "transparent",
                          },
                          "&:hover": {
                            backgroundColor: "transparent",
                          },
                          "&:focus": {
                            backgroundColor: "transparent",
                          },
                          "&:active": {
                            backgroundColor: "transparent",
                          },
                        }}
                        id="basic-button"
                        aria-controls={open ? "grouped-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                        className={`more-options ${open ? "selected" : ""} ${
                          ChatsStore.isGenerateImage ||
                          ChatsStore.isGlobalSearch
                            ? "checked"
                            : ""
                        }`}
                      >
                        <div ref={ContinerModeRef} className="auto-container">
                          <span className="container_icons-web-search">
                            {ChatsStore.isGlobalSearch && (
                              <LanguageIcon
                                sx={{
                                  fontSize: "1.3rem",
                                  color: "var(--Main_icons_color)",
                                  marginRight: "1px",
                                  "@media (max-width: 900px)": {
                                    fontSize: "1.6rem",
                                  },
                                }}
                              />
                            )}
                            {ChatsStore.isGenerateImage && (
                              <ImageOutlinedIcon
                                sx={{
                                  fontSize: "1.3rem",
                                  color: "var(--Main_icons_color)",
                                  "@media (max-width: 900px)": {
                                    fontSize: "1.6rem",
                                  },
                                }}
                              />
                            )}
                            {!ChatsStore.isGlobalSearch &&
                              !ChatsStore.isGenerateImage &&
                              "Auto"}
                          </span>
                          <span className="arrow-container d-flex justify-content-center align-items-center">
                            {open ? (
                              <ArrowUpIcon className="return-versions-arrow-white-black" />
                            ) : (
                              <ArrowDown className="return-versions-arrow-white-black" />
                            )}
                          </span>
                        </div>
                      </ListItemButton>
                    </List>
                    <Menu
                      id="grouped-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      sx={{ "& .MuiMenu-list": { width: "210px" } }}
                      className="menu-more-options"
                    >
                      <MenuItem
                        onClick={handleClose}
                        className={`itemMenu ${
                          ChatsStore.isGlobalSearch ? "selected" : ""
                        }`}
                      >
                        <IconButton
                          sx={{
                            ...BtnItemStyleForOption,
                            justifyContent: "center",
                          }}
                          onClick={handleSwitchGlobalSearch}
                        >
                          <span className="d-flex">
                            <LanguageIcon
                              sx={{
                                fontSize: "1.3rem",
                                color: ChatsStore.isGlobalSearch
                                  ? "var(--M-background100)"
                                  : "var(--M-fontColor38)",
                                marginRight: "3px",
                                "@media (max-width: 900px)": {
                                  fontSize: "1.6rem",
                                },
                              }}
                            />
                            <Typography
                              className={`generate-img-text ${
                                ChatsStore.isGlobalSearch && "active"
                              }`}
                            >
                              Global search
                            </Typography>
                          </span>
                          <IOSSwitch
                            className="generate-image-switch"
                            checked={ChatsStore.isGlobalSearch}
                            onChange={handleSwitchGlobalSearchChange}
                          />
                        </IconButton>
                      </MenuItem>
                      <MenuItem
                        onClick={handleClose}
                        className={`itemMenu ${
                          ChatsStore.isGenerateImage ? "selected" : ""
                        }`}
                      >
                        <IconButton
                          sx={{
                            ...BtnItemStyleForOption,
                          }}
                          onClick={handleSwitchGenerateImage}
                        >
                          <span className="d-flex">
                            <ImageOutlinedIcon
                              sx={{
                                fontSize: "1.3rem",
                                color: ChatsStore.isGenerateImage
                                  ? "var(--M-background100)"
                                  : "var(--M-fontColor38)",
                                marginRight: "3px",
                                "@media (max-width: 900px)": {
                                  fontSize: "1.6rem",
                                },
                              }}
                            />
                            <Typography
                              className={`generate-img-text ${
                                ChatsStore.isGenerateImage && "active"
                              }`}
                            >
                              Generate image
                            </Typography>
                          </span>
                          <IOSSwitch
                            className="generate-image-switch"
                            checked={ChatsStore.isGenerateImage}
                            onChange={handleSwitchGenerateImageChange}
                          />
                        </IconButton>
                      </MenuItem>
                    </Menu>
                  </div>

                  <div className="prompt-line generate"></div>
                  {/*Output language button*/}
                  <Tooltip
                    title="Turn off image generation mode"
                    arrow
                    componentsProps={tooltipStyle}
                    disableHoverListener={
                      !ChatsStore.isGenerateImage || mobileSize
                    }
                    disableFocusListener={
                      !ChatsStore.isGenerateImage || mobileSize
                    }
                  >
                    <span>
                      <IconButton
                        sx={{
                          ...BtnStyle,
                          opacity: ChatsStore.isGenerateImage
                            ? "0.5!important"
                            : "1 !important",
                          cursor: "pointer !important",
                          padding: { md: "6px 16px" },
                          marginLeft: "8px",
                        }}
                        onClick={handleSelectTranslateOutputLang}
                        disabled={ChatsStore.isGenerateImage}
                      >
                        <OutputLangIcon className={`improvePromptIcon`} />
                        <Typography sx={PromptLibTextStyle}>
                          {selectedOutputLang
                            ? selectedOutputLang
                            : "Output language"}
                        </Typography>
                      </IconButton>
                    </span>
                  </Tooltip>
                </div>
                {/* ===================================*/}
              </div>
              {!props.isResponseRegenerating || isMaxChatReceivesRes ? (
                <StopResponse isStopAll={true} place="user-input" />
              ) : (
                <button
                  className={`send-question-btn`}
                  onClick={handleSendClick}
                >
                  <img src="/images/send-question-icon.svg" />
                </button>
              )}
            </div>
          </div>
        </div>
        {openPromptLibrary && (
          <PromptLibrary
            open={openPromptLibrary}
            handleClose={handleClosePromptLibrary}
            setLibraryPrompt={handleSetLibraryPrompt}
          />
        )}
        {openLanguagesModal && (
          <LanguageModel
            selectedLang={
              languageModalType === "Prompt"
                ? selectedPromptLang
                : selectedOutputLang
            }
            languageModalType={languageModalType}
            setSelectedLang={handleSelectLanguage}
            handleTranslate={handleTranslate}
            handleClose={() => setOpenLanguagesModal(false)}
            open={openLanguagesModal}
          />
        )}
      </div>
    );
  }
);

export default OneQueryInput;
